import React from 'react';
import Plot from 'react-plotly.js';

class SheepAnalyticsStockflow extends React.Component {
  render() {
    var trace1 = {
  
      x: ['2015', '2016', '2017', '2018', '2019', '2020'], 
      
      close: [200000, 450000, 850000, 600000, 1100000, 750000], 
      
      decreasing: {line: {color: 'red'}}, 
      
      high: [210000, 450000, 880000, 850000, 1100000, 1100000], 
      
      increasing: {line: {color: 'green'}}, 
      
      line: {color: 'rgba(31,119,180,1)'}, 
      
      low: [100000, 200000, 450000, 600000, 500000, 650000], 
      
      open: [100000, 200000, 450000, 850000, 600000, 1100000], 
      
      type: 'candlestick', 
      xaxis: 'x', 
      yaxis: 'y'
    };
    
    var data = [trace1];
    
    var layout = {
      dragmode: 'zoom', 
      margin: {
        r: 10, 
        t: 25, 
        b: 40, 
        l: 60
      }, 
      showlegend: false, 
      xaxis: {
        autorange: true, 
        domain: [0, 1], 
        range: ['2017-01-03 12:00', '2017-02-15 12:00'], 
        rangeslider: {visible: false}, 
        title: 'Date', 
        type: 'category'
      }, 
      yaxis: {
        autorange: true, 
        domain: [0, 1], 
        range: [114.609999778, 137.410004222], 
        type: 'linear'
      }
    };
    return (
      <React.Fragment>
        <h5 className="text-center mt-3">Sheep Stockflow - Open/Close Valuations</h5>
        <Plot
          data={data}
          layout={layout}
          config={{displayModeBar: false}}
          className="w-100"
        />
      </React.Fragment>

    );
  }
}

export default SheepAnalyticsStockflow;



